import { createContext, useContext, useState } from 'react'

import { Option } from 'components/Controls/Select/Select'
import { MakeAllOptional } from 'types/helpers'

const FormDataContext = createContext<any>(null)

export const CreateCreativeFormDataProvider = ({ children }: { children: React.ReactNode }) => {
  const [data, setData] = useState<ContextType>({
    creativeType: 0,
    files: [],
    name: '',
    description: '',
    externalLink: '',
  })

  const setValues = (values: MakeAllOptional<ContextType>) => {
    setData((prevData: ContextType) => ({
      ...prevData,
      ...values,
    }))
  }

  return <FormDataContext.Provider value={{ data, setValues }}>{children}</FormDataContext.Provider>
}

export const useData = () => useContext<IUseData>(FormDataContext)

interface IUseData {
  data: ContextType
  setValues: (val: MakeAllOptional<ContextType>) => void
}

interface ContextType {
  creativeType: 0 | 1 | 2 | 3 | 4 | 5 | 10 | 11
  files: File[]
  name: string
  description: string
  externalLink: string | null
  streamUrl?: string | null
  robloxUrl?: string | null
  robloxSelect?: Option
  robloxLength?: number | null
}

